var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import axios from 'axios';
import T from '../../../app/Locale';
import Modal from '../../Components/ComponentModal';
import DeleteUserRadio from './DeleteUserRadio';
import ComponentButton from '../../../app/Components/ComponentButton';
import ComponentInput from '../../Components/ComponentInput';
import ComponentMessage from '../../ComponentMessage';
import Checkbox from '../../Components/ComponentCheckbox';
const DeleteUserModal = ({ firstName, closeModal }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [feedback, setFeedback] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [text, setText] = useState(null);
    const [consent, setConsent] = useState(false);
    const [errors, setErrors] = useState({});
    function userDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const tempError = {};
            if (!feedback) {
                tempError.feedback = 'deleteUserModal.feedback.noChoiceSelected';
            }
            if (feedback === 'option6' && !text) {
                tempError.other = 'deleteUserModal.feedback.textfield';
            }
            if (!consent) {
                tempError.consent = 'deleteUserModal.feedback.notGivenConsent';
            }
            setErrors(Object.assign({}, tempError));
            if (Object.keys(tempError).length === 0) {
                try {
                    setIsLoading(true);
                    const feedbackToSend = feedback === 'option6' ? text : T.translate(`deleteUserModal.feedback.${feedback}`);
                    const response = yield axios.post('/user/delete', { feedback: feedbackToSend });
                    window.location.href = response.data;
                }
                catch (e) {
                    setShowMessage(true);
                }
            }
        });
    }
    return (_jsxs("div", { children: [showMessage && (_jsx(ComponentMessage, { message: T.translate('deleteUserModal.feedback.deleteFailed'), isSuccessful: false })), _jsxs(Modal, Object.assign({ closeModal: closeModal }, { children: [_jsxs("div", { children: [_jsx("h2", { children: T.translate('deleteUserModal.feedback.title', { firstName }) }), _jsx("h3", { children: T.translate('deleteUserModal.feedback.subTitle') }), errors.feedback && (_jsx("strong", { children: T.translate(errors.feedback) })), _jsx(DeleteUserRadio, { text: 'option1', onChange: () => setFeedback('option1') }), _jsx(DeleteUserRadio, { text: 'option2', hint: T.translate('deleteUserModal.feedback.description2'), currentFeedback: feedback, onChange: () => setFeedback('option2') }), _jsx(DeleteUserRadio, { text: 'option3', hint: T.translate('deleteUserModal.feedback.description3'), currentFeedback: feedback, onChange: () => setFeedback('option3') }), _jsx(DeleteUserRadio, { text: 'option4', hint: T.translate('deleteUserModal.feedback.description4'), currentFeedback: feedback, onChange: () => setFeedback('option4') }), _jsx(DeleteUserRadio, { text: 'option5', onChange: () => setFeedback('option5') }), errors.other && (_jsx("strong", { children: T.translate('deleteUserModal.feedback.textfield') })), feedback === 'option5' && (_jsx(ComponentInput, { onChange: setText }))] }), errors.consent && (_jsxs("strong", { children: [T.translate(errors.consent), _jsx("br", {})] })), _jsx("br", {}), _jsx(Checkbox, { label: T.translate('deleteUserModal.feedback.checkbox'), id: 'checkbox', onChange: setConsent }), _jsx("div", Object.assign({ className: 'row' }, { children: _jsxs("div", Object.assign({ className: 'column small 12' }, { children: [_jsx(ComponentButton, Object.assign({ onClick: userDelete, type: 'button', classes: 'button redalert', isLoading: isLoading, id: 'delete-user-button' }, { children: T.translate('user.delete') })), _jsx(ComponentButton, Object.assign({ onClick: closeModal, type: 'button', classes: 'button transparent' }, { children: T.translate('user.undo') }))] })) }))] }))] }));
};
DeleteUserModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    firstName: PropTypes.string
};
export default DeleteUserModal;
